import { RESET_MANAGEMENT, SET_MANAGEMENT, SET_MANAGEMENT_MULTI } from "services/redux/action-types";
import HelperObject from "utils/helper-object";
import _ from 'lodash';
import { managementConstants } from 'services/redux/management/constants'

export function setManagement( key, payload ) {
	return {
		type: SET_MANAGEMENT,
		key: key,
		payload
	}
}

export function setManagementMulti( values = {} ) {
	return {
		type: SET_MANAGEMENT_MULTI,
		payload: values
	}
}

export function setManagementByGuid( key, values = {} ) {
	const data = HelperObject.groupByGuid( values );
	
	return {
		type: SET_MANAGEMENT,
		key: key,
		payload: data
	}
}

export function setManagementMultiByGuid( values = {} ) {
	const data = {};
	_.forEach( values, ( value, key ) => {
		data[ key ] = HelperObject.groupByGuid( value );
	} );
	
	return {
		type: SET_MANAGEMENT_MULTI,
		payload: data
	}
}

export function resetManagement() {
	return {
		type: RESET_MANAGEMENT
	}
}

export const setChartDateRange = ( range ) => {
	return {
		type: SET_MANAGEMENT,
		key: managementConstants.MANAGEMENT_CHART_DATE,
		payload: range
	}
}
